"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHovered = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = require("react");
const useHovered = function () {
  let {
    onMouseEnter: providedOnMouseEnter,
    onMouseLeave: providedOnMouseLeave
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [isHovered, setIsHovered] = (0, _react.useState)(false);
  const onMouseEnter = (0, _react.useMemo)(() => (0, _lodestarUtils.callAllHandlers)(providedOnMouseEnter, () => {
    setIsHovered(true);
  }), [providedOnMouseEnter]);
  const onMouseLeave = (0, _react.useMemo)(() => (0, _lodestarUtils.callAllHandlers)(providedOnMouseLeave, () => {
    setIsHovered(false);
  }), [providedOnMouseLeave]);
  const result = {
    isHovered,
    onMouseEnter,
    onMouseLeave
  };
  return result;
};
exports.useHovered = useHovered;
//# sourceMappingURL=useHovered.js.map